import styled from "styled-components"
// eslint-disable-next-line import/no-extraneous-dependencies
import { Filter } from "@styled-icons/bootstrap"

export const StyledFilterIcon = styled(Filter)`
  color: var(--primary-accent);
  margin-right: 0.625rem;
`
